import qs from "qs";
import { Transactions } from "types/Models/books";
import { Pagination } from "types/Models/pagination";
import { emptyApi } from "./emptyApi";

export type CategorisationHistoryItem = {
  uuid: string;
  category_name: string;
  identifier: number;
  txn_count: number;
  last_used: string;
};

export type CategorisationHistoryResponse = CategorisationHistoryItem[];

export type CategorisationTxnsResponse = {
  transactions: Transactions[];
} & Pagination;

export const categorisationHistoryApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getCategorisationHistory: build.query<
      CategorisationHistoryResponse,
      {
        merchantId: string;
        startDate?: string;
        endDate?: string;
        groupId: string;
        entityId: string;
      }
    >({
      query: ({ merchantId, startDate, groupId, entityId, endDate }) => {
        const queryUrl = qs.stringify(
          {
            start_date: startDate,
            end_date: endDate,
          },
          { skipNulls: true, addQueryPrefix: true }
        );

        return {
          url: `/api/inkle/bookkeeping/group/${groupId}/entity/${entityId}/merchant/${merchantId}/categorisation-history/${queryUrl}`,
        };
      },
      providesTags: ["CATEGORISATION_HISTORY"],
    }),

    getCategorisationTxns: build.query<
      CategorisationTxnsResponse,
      {
        merchantId: string;
        categoryId: string;
        pageNum?: number;
        groupId: string;
        entityId: string;
        startDate?: string;
        endDate?: string;
      }
    >({
      query: ({
        merchantId,
        categoryId,
        groupId,
        entityId,
        pageNum,
        startDate,
        endDate,
      }) => {
        const queryUrl = qs.stringify(
          {
            page_num: pageNum,
            start_date: startDate,
            end_date: endDate,
          },
          { skipNulls: true, addQueryPrefix: true }
        );

        return {
          url: `/api/inkle/bookkeeping/group/${groupId}/entity/${entityId}/merchant/${merchantId}/transaction-category/${categoryId}/transactions/${queryUrl}`,
        };
      },
      providesTags: ["CATEGORISATION_HISTORY_TXNS"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCategorisationHistoryQuery,
  useLazyGetCategorisationHistoryQuery,
  useGetCategorisationTxnsQuery,
  useLazyGetCategorisationTxnsQuery,
} = categorisationHistoryApi;
